// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2I7rM","emails":"CreateEditClinics_emails__1DuIl","emailTagLabel":"CreateEditClinics_emailTagLabel__2UZ1E"};